import Cookies from "js-cookie";

import type { IAuthenticated } from "@/context";

export const AUTH_USER_KEY = "authUser";

/**
 * Mescla cookie e sessionStorage: o cookie pode estar incompleto na mesma hora
 * em que o AuthProvider já tem token (race); session espelha o payload do login.
 */
export function readAuthUserMerged(): IAuthenticated {
  let cookieData: Partial<IAuthenticated> = {};
  let sessionData: Partial<IAuthenticated> = {};
  try {
    const c = Cookies.get(AUTH_USER_KEY);
    if (c) cookieData = JSON.parse(c);
  } catch {
    /* ignore */
  }
  try {
    const s = sessionStorage.getItem(AUTH_USER_KEY);
    if (s) sessionData = JSON.parse(s);
  } catch {
    /* ignore */
  }
  const merged: IAuthenticated = {
    isAuthenticated: !!(cookieData.token || sessionData.token),
    id: String(cookieData.id ?? sessionData.id ?? ""),
    first_name: cookieData.first_name ?? sessionData.first_name,
    last_name: cookieData.last_name ?? sessionData.last_name,
    email: cookieData.email ?? sessionData.email,
    token: cookieData.token || sessionData.token || "",
    organization_root_id:
      cookieData.organization_root_id ||
      sessionData.organization_root_id ||
      "",
    roles: cookieData.roles ?? sessionData.roles,
  };
  return merged;
}

export function persistAuthUserSessionMirror(payloadJson: string): void {
  try {
    sessionStorage.setItem(AUTH_USER_KEY, payloadJson);
  } catch {
    /* quota / private mode */
  }
}

export function clearAuthUserSessionMirror(): void {
  try {
    sessionStorage.removeItem(AUTH_USER_KEY);
  } catch {
    /* ignore */
  }
}
